import React, { useState } from 'react';
import ReactJson from 'react-json-view';
import { Row, Col, Input, Button } from 'reactstrap';
import useLoading from '../../../customHooks/useLoading';
import apiClient from '../../../apiClient';

export default function CsApi ({ tabId }) {
    const { setLoading } = useLoading();
    const [s_mawb, set_s_mawb] = useState('');
    const [data, setData] = useState([]);

    const getData = async () => {
        setLoading(true);
        const res = await apiClient.get(`/csApi/${s_mawb}`);
        setLoading(false);
        if (res.status === 200) {
            setData(res.data);
        }
    }

    return (
        <Row>
            <Col md={12}>
                <Input 
                    type={'text'} 
                    value={s_mawb} 
                    onChange={(e) => set_s_mawb(e.target.value)} 
                    style={{ width: '200px' }}
                    className={'d-inline mr-2'}
                />
                <Button
                    className={'d-inline'}
                    disabled={!s_mawb || s_mawb.length < 11}
                    onClick={() => getData()}
                >
                    Search
                </Button>
            </Col>
            <Col md={12} className={'mt-2'}>
                <h4>Results:</h4>
                {
                    data.length > 0 && 
                    <ReactJson src={data} displayDataTypes={false} />
                }
            </Col>
        </Row>
    );
}